import { CommonMainPage } from '../../widgets/utility/CommonMainPage'
import { DomainOverviewFilters } from './widgets/domain-overview-filters/DomainOverviewFilters'
import { BpTabs } from '../../shared/components/utility/tabs/BpTabs'
import { BpTab } from '../../shared/components/utility/tabs/tab/BpTab'
import { PagesTable } from './widgets/pages-table/PagesTable'
import { AffiliatesTable } from './widgets/affiliates-table/AffiliatesTable'
import { PagesPanel } from './widgets/pages-panel/PagesPanel'
import { AffiliatesPanel } from './widgets/affiliates-panel/AffiliatesPanel'
import { useAppDispatch, useAppSelector } from '../../app/store/hooks/Redux'
import {
  selectDetailedInfoActiveTab,
  setDetailedInfoActiveTab,
  TDetailedInfoTabs,
} from './model/domainOverviewSlice'
import { useNavigate } from 'react-router-dom'
import React from 'react'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'

import styles from './DomainOverviewPage.module.scss'

export const DomainOverviewPage = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const activeTab = useAppSelector(selectDetailedInfoActiveTab)

  return (
    <CommonMainPage title={t('navigation.domainOverview')}>
      <DomainOverviewFilters />
      <BpTabs
        active={activeTab}
        back={() => navigate('/organic-results')}
        className={clsx(styles.tabs)}
        size={'md'}
        onToggle={(e) => dispatch(setDetailedInfoActiveTab(e as TDetailedInfoTabs))}
      >
        <BpTab panel={<PagesPanel />} title={t('pages.domainOverview.pages')}>
          <PagesTable />
        </BpTab>
        <BpTab panel={<AffiliatesPanel />} title={t('pages.domainOverview.affiliates')}>
          <AffiliatesTable />
        </BpTab>
      </BpTabs>
    </CommonMainPage>
  )
}
